import "babel-polyfill"
import Vue                  from "vue"
import vueHeadful           from "vue-headful"
import VueRouter            from "vue-router"
import VeeValidate          from "vee-validate"
import Vue2Filters          from "vue2-filters"

import Buefy                from "buefy"
import VueScrollTo          from 'vue-scrollto'
import "buefy/dist/buefy.css"

import VueToastr            from "@deveodk/vue-toastr"
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css"

//import VueAnalytics         from "vue-analytics"
import App                  from "~/App.vue"
import config               from "./config"
import store from "./store"
import routes from "./routes"
import "./registerServiceWorker"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { i18n } from "./i18n/i18n.js"
import veeDe    from "./i18n/de-vee-messages"


import { library } from "@fortawesome/fontawesome-svg-core"
import {
    faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle,
    faExclamationCircle, faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload,
    faUser, faSpinner, faCaretRight, faBars, faShoppingCart, faTag, faSearchPlus,
    faSadTear, faPhone, faFax, faEnvelope, faLaptop, faSyncAlt, faEdit,
    faGlobeEurope, faArrowCircleLeft, faClipboardCheck, faThumbsUp, faRedo
} from "@fortawesome/free-solid-svg-icons"

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle,
    faExclamationCircle, faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload,
    faUser, faSpinner, faCaretRight, faBars, faShoppingCart, faTag, faSearchPlus,
    faSadTear, faPhone, faFax, faEnvelope, faLaptop, faSyncAlt, faEdit,
    faGlobeEurope, faArrowCircleLeft, faClipboardCheck, faThumbsUp, faRedo
)

Vue.component("vue-fontawesome", FontAwesomeIcon)
Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.component("vue-headful", vueHeadful)

Vue.use(VueToastr, {
    defaultPosition: "toast-top-center",
    defaultType: "info",
    defaultTimeout: 5000
})

Vue.config.productionTip = false

Vue.use(Buefy, {
    defaultIconComponent: 'vue-fontawesome',
    defaultIconPack: 'fas',
})
Vue.use(VueScrollTo)

import I18nGroup            from "@/components/i18n/I18nGroup"
Vue.component ("i18n-group", I18nGroup)

console.log (config)
Vue.use         (Vue2Filters)
Vue.use         (VueRouter)
Vue.use         (VeeValidate, {
    locale: localStorage.getItem("language") || config.defaultLocale,
    dictionary: {
        de: {attributes: veeDe.attributes, messages: veeDe.messages}
    }
})
Vue.use         (require ("vue-moment"))

const router = new VueRouter({
    mode: "history",
    routes
})

router.beforeEach ((to, from, next) => {
    // console.log ("Try to route to", to.path)
    store.dispatch ("loginPossible").then (response => {
        //console.log ("loginPossible returned", to.path, to.meta.requiresAuth)
        //const loginSubdomain = localStorage.getItem ("subdomain")
        const subdomain      = window.location.host.split (".", 1) [0]
        const cookie         = document.cookie.split (";").filter (s => s.indexOf ("shopDomain") >= 0)
        if (cookie.length > 0) {
            const loginSubdomain = cookie [0].split ("=") [1]
            if (loginSubdomain != subdomain) {
                // redirect to the corret subdomain
                const url = window.location.href.replace (`/${subdomain}.`, `/${loginSubdomain}.`)
                window.location.href = url
            }
        }
        if (! store.getters.getUserTokenState && to.meta.requiresAuth) {
            //console.log ("Request auth but not logged in")
            next ("/")
        } else {
            next ()
        }
    })
})


if (false) {
    Vue.use(VueAnalytics, {
    id: "UA-111111111",
    router
    })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app")
